import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from '../../../../auth/service';

@Injectable({
  providedIn: 'root'
})
export class EmailVerifyResolver implements Resolve<any> {
  constructor(private _authService: AuthenticationService, private _router: Router) {}

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    const token = route?.params?.token?.trim(); // Get the token from the route
    return this._authService.emailVerfiy(token).pipe(
      catchError((error) => {
        return error; 
      })
    );
  }
}